module.exports = __webpack_public_path__ + "img/santagata.17fe8797.jpeg";